import { IntlShape } from "react-intl";
import { FieldValues, UseFormSetError } from "react-hook-form";

import { PAST_DATE_ERROR_TYPE, isDeadlineDateInPast } from "./isDeadlineDateInPast";
import {
  getRequiredMessage,
  getSelectableDateMessage,
  getValidTimeMessage,
  isEmptyValue,
  isValidTimeValue,
} from "./validationMessages";

export function setRequiredFieldError(
  setError: UseFormSetError<FieldValues>,
  fieldPath: string,
  value: unknown,
  intl: IntlShape,
): boolean {
  if (!isEmptyValue(value)) return true;

  setError(fieldPath, {
    type: "manual",
    message: getRequiredMessage(intl),
  });
  return false;
}

export function setPastSelectableDateError(
  setError: UseFormSetError<FieldValues>,
  fieldPath: string,
  value: unknown,
  intl: IntlShape,
): boolean {
  if (!isDeadlineDateInPast(value)) return true;

  setError(fieldPath, {
    type: PAST_DATE_ERROR_TYPE,
    message: getSelectableDateMessage(intl),
  });
  return false;
}

export function setTimeFieldError(
  setError: UseFormSetError<FieldValues>,
  fieldPath: string,
  value: unknown,
  intl: IntlShape,
  required = true,
): boolean {
  if (isEmptyValue(value)) {
    if (!required) return true;
    setError(fieldPath, {
      type: "manual",
      message: getRequiredMessage(intl),
    });
    return false;
  }

  if (!isValidTimeValue(value)) {
    setError(fieldPath, {
      type: "manual",
      message: getValidTimeMessage(intl),
    });
    return false;
  }

  return true;
}
